import React, { useEffect } from 'react';
import { useParallaxController } from 'react-scroll-parallax';

/**
 * Triggers parallax controller to recalculate element positions when the
 * route or layout changes. Fixes parallax effects not updating after navigation
 * or when content/images load.
 */
export default function ParallaxUpdater() {
  const parallaxController = useParallaxController();

  useEffect(() => {
    if (!parallaxController) return;

    const update = () => {
      parallaxController.update();
    };

    // Recalculate when layout mounts (e.g. route change)
    update();

    // Run again after paint so DOM/layout is fully settled
    const raf = requestAnimationFrame(update);

    // Recalculate after window load (images etc.) and on resize
    window.addEventListener('load', update);
    window.addEventListener('resize', update);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('load', update);
      window.removeEventListener('resize', update);
    };
  }, [parallaxController]);

  return null;
}
